/**
 * myDaySnoozePref.ts — Home tabs H-3b-2 (spec §4.1): My day's snoozed items,
 * device-local in localStorage under the gss.pref. namespace (the
 * excludeTestPref / homeTabPref precedent).
 *
 * A stand-in for the spec's server-side `snoozed_items` (§6): per device,
 * never per account. The value is { itemKey: untilDay } — the London day
 * ("2026-10-19") the item comes back on. Reads and writes go through
 * draftStorage, so a blocked or full storage is NON-FATAL — a failed read is
 * "nothing snoozed", and a failed write snoozes for this page only.
 */
import { readDraft, writeDraft } from './draftStorage'

export const MY_DAY_SNOOZED_KEY = 'gss.pref.myDaySnoozed'

const DAY = /^\d{4}-\d{2}-\d{2}$/

/** Every remembered snooze still in force on `today` (a London day): an
 *  entry whose day has come is dropped, and so is anything malformed. */
export function readSnoozed(today: string): Record<string, string> {
  const v = readDraft<unknown>(MY_DAY_SNOOZED_KEY)
  const out: Record<string, string> = {}
  if (!v || typeof v !== 'object' || Array.isArray(v)) return out
  for (const [k, until] of Object.entries(v as Record<string, unknown>)) {
    if (typeof until === 'string' && DAY.test(until) && until > today) out[k] = until
  }
  return out
}

export function writeSnoozed(snoozed: Record<string, string>): void {
  writeDraft(MY_DAY_SNOOZED_KEY, snoozed)
}
